import type { ReviewItem } from "../../api/types";
import { t } from "../../i18n/t";
import { hasDetails, oneLineSummary } from "./suggestions";

/**
 * xmg-coafast: a review row's text as one plain line, with the mapper's full message under a "Details"
 * disclosure. A message that is already short is shown whole, with no disclosure. Never shows a role enum
 * name of its own: the line is the server's `summary` (or the message's first sentence).
 */
export function ItemSummary({ item }: { item: ReviewItem }): JSX.Element {
  return (
    <>
      <span data-testid={`review-summary-${item.id}`}>{oneLineSummary(item)}</span>
      {hasDetails(item) ? (
        <details data-testid={`review-details-${item.id}`}>
          <summary>{t("review.details")}</summary>
          <p>{item.message}</p>
        </details>
      ) : null}
    </>
  );
}
